export const GET_PQ = 'GET_PQ';
export const GET_P_ANS = 'GET_P_ANS';
export const NEW_QUESTION = 'NEW_QUESTION';
export const PQ_SUMMERY = 'PQ_SUMMERY';
export const DELETE_QUESTION = 'DELETE_QUESTION';
export const USER_ANSWERS = 'USER_ANSWERS';
